import { render, staticRenderFns } from "./app.vue?vue&type=template&id=1fda0c30&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&id=1fda0c30&scoped=true&lang=css&"
import style1 from "./app.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda0c30",
  null
  
)

export default component.exports